
import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CounsellorPublicProfileVM } from "../models";
import { BaseService } from "./base.service";
import { CalendarVM } from "../models/CalendarVM";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class CounsellorService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  public getCounsellorProfile(mbNumber: string): Observable<CounsellorPublicProfileVM> {
    return this.http.get('/api/counsellor/profile/' + mbNumber, this.getHttpOptions(true)).pipe(
      map(resp => resp as CounsellorPublicProfileVM));
  }

  public getCounsellorCalendar(mbNumber: string, wc: Date): Observable<CalendarVM> {
    return this.http.get('/api/counsellor/calendar/' + mbNumber + '/' + wc.toISOString()
      , this.getHttpOptions(true)).pipe(
      map(resp => resp as CalendarVM));
  }

}
